import { createAction, createAsyncAction } from 'typesafe-actions';
import {
  //  ErrorMessage,
  //   Entry,
  User, ErrorData, UserData, Booking, ItineraryData
} from '../../services/types';

export interface UserDataPayload {
  details: UserData;
  token: string;
  message?: string;

}

export const loginUser = createAsyncAction(
  'LOGIN_REQUEST',
  'LOGIN_SUCCESS',
  'LOGIN_FAILURE'
)<User, UserDataPayload, ErrorData>();

export const verifyToken = createAsyncAction(
  'VERIFY_TOKEN_REQUEST',
  'VERIFY_TOKEN_SUCCESS',
  'VERIFY_TOKEN_FAILURE'
)<undefined, undefined, ErrorData>();

export const getShipItinerary = createAsyncAction(
  'GET_ITINERARY_REQUEST',
  'GET_ITINERARY_SUCCESS',
  'GET_ITINERARY_FAILURE'
)<Booking[], ItineraryData[], ErrorData>();

export const clearUserData = createAction('CLEAR_USER_DATA')();



